









































import { Component, Vue } from 'vue-property-decorator';
import { institutionServer, performanceServer } from '@/api/installServer';
import { arrayToTree } from '@/util/array';
import { deepClone } from '@/util/deepClone';
import ChooseDeptOfStaff from '@/views/inspectionContents/checklist/unit/choosePeople.vue';

@Component({
  components: { ChooseDeptOfStaff },
})
export default class EditProp extends Vue {
  private visible = false;
  private formData: any = {
    description: '',
    executors: [],
    id: '',
    inspectedList: [],
  };
  private subSpaceByAuthOptions: any = [];
  private loadingData: any = false;
  private chooseStaffType: any = '';

  private showDialog(data: any) {
    this.getSubSpaceByAuth();
    this.formData.id = data;
    this.getDetailData(data);
    this.visible = true;
  }

  /**
   * @desc 选择执行人的弹窗
   * */
  choseSponsor(type: any) {
    this.chooseStaffType = type;
    let chooseStaffArr: any = [];
    if (type === 'executors') {
      chooseStaffArr = deepClone(this.formData.executors);
    }
    (this.$refs['ChooseDeptOfStaff'] as any).showDialog(chooseStaffArr, 'more');
  }
  getStaffData(data: any) {
    if (this.chooseStaffType === 'executors') {
      this.formData.executors = data;
    }
  }

  private getSubSpaceByAuth() {
    // 发起接口请求，获取分页数据
    institutionServer
      .getAllData({})
      .then((res: any) => {
        this.subSpaceByAuthOptions = arrayToTree(res.data);
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  private hideDialog() {
    this.formData = {
      description: '',
      executors: [],
      id: '',
      inspectedList: [],
    };
    this.visible = false;
    this.$emit('hideDialogHandel');
  }

  private submitForm() {
    const executors: any = this.formData.executors.map((item: any) => item.id);
    this.loadingData = true;
    performanceServer
      .editTask({
        id: this.formData.id,
        description: this.formData.description,
        inspectedList: this.formData.inspectedList,
        executors: executors,
        joinLeaderIds: [],
        joinStaffIds: [],
      })
      .then((res: any) => {
        this.loadingData = false;
        if (res.code === '200') {
          this.$message.success('保存成功！');
          this.hideDialog();
        } else {
          this.$message.warning(res.msg);
        }
      });
  }

  // 详情
  private getDetailData(id: any) {
    this.loadingData = true;
    performanceServer.getTemplateDetail(id).then((res: any) => {
      this.loadingData = false;
      if (res.code === '200') {
        this.formData.description = res.data.description;
        this.formData.inspectedList = res.data.inspectedUtils.map((item: any) => item.inspectedUnitId);
        this.formData.executors = res.data.executors.map((item: any) => {
          return { id: item.staffId, name: item.staffName };
        });
      } else {
        this.$message.warning(res.msg);
      }
    });
  }
}
